import { render, staticRenderFns } from "./LivingPlacePicker.vue?vue&type=template&id=27197415&scoped=true"
import script from "./LivingPlacePicker.vue?vue&type=script&lang=js"
export * from "./LivingPlacePicker.vue?vue&type=script&lang=js"
import style0 from "./LivingPlacePicker.vue?vue&type=style&index=0&id=27197415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27197415",
  null
  
)

export default component.exports